import React from 'react';
import { ErrorsWrapperLayoutProps } from 'ui-builder';

export default function ShadcnErrorsWrapperLayout(props: ErrorsWrapperLayoutProps) {
  const errors = props.errors;
  return (
    <>
      {props.children}
      {errors && errors.length > 0 && (
        <div className="mt-1.5 space-y-0.5">
          {errors.map((error) => (
            <div className="text-xs text-rose-600" key={error}>
              {error}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
